<template>
  <CardedForm
    ref="carded_owners_contact_form_ref"
    id="owners_contact_form"
    title="Leave us a message"
    :is_loading="is_loading || is_owner || is_in_admin_view == true"
    @on-submit-form="on_send_message"
    :errors="contact_form_errors"
    :message="contact_us_success_message"
    @on-auto-fill="on_auto_fill"
    @on-close-message="on_hide_message"
  >
    <v-alert dense text type="warning" v-if="is_owner && is_in_admin_view == false">
      Please note that you
      <strong> can not send your own business a message </strong>
    </v-alert>

    <TwoTextFields
      left_label="First name"
      left_icon="mdi-account-circle"
      left_prop="first_name"
      :left_value="first_name"
      :left_validation_rules="first_name_rules"
      :left_required="true"
      right_label="Last name"
      right_icon="mdi-account-circle"
      right_prop="last_name"
      :right_value="last_name"
      :right_validation_rules="last_name_rules"
      :right_required="false"
      @input="on_assign_first_name_and_last_name"
      :disabled="is_loading || is_owner || is_in_admin_view == true"
    ></TwoTextFields>

    <TwoTextFields
      left_label="Email Address"
      left_icon="mdi-email-variant"
      left_prop="email"
      :left_value="email"
      :left_validation_rules="email_rules"
      :left_required="true"
      right_label="Phone Number"
      right_icon="mdi-phone"
      right_prop="phone_number"
      :right_value="phone_number"
      :right_validation_rules="phone_number_rules"
      :right_required="true"
      right_type="phone"
      @input="on_assign_email_and_phone_number"
      :disabled="is_loading || is_owner || is_in_admin_view == true"
    ></TwoTextFields>

    <TextArea
      label="Message"
      v-model="message"
      :disabled="is_loading || is_owner || is_in_admin_view == true"
      :validation_rules="message_rules"
    ></TextArea>
  </CardedForm>
</template>

<script>
import CardedForm from "./../components/CardedForm";
import TwoTextFields from "./../components/TwoTextFields";
import TextArea from "./../components/TextArea";
import ServerClient from "../lib/ServerClient";
import Utils from "./../lib/Utils";
export default {
  name: "BusinessViewSendMessage",
  components: {
    CardedForm,
    TwoTextFields,
    TextArea,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    user_id: {
      type: Number,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    this_user: null,
    first_name: "",
    first_name_rules: [
      Utils.validate.is_required("First name is required"),
      Utils.validate.min_max_length(
        3,
        25,
        "First name should be between 3 and 25 characters long"
      ),
    ],
    last_name: "",
    last_name_rules: [
      Utils.validate.is_required("Last name is required"),
      Utils.validate.min_max_length(
        3,
        25,
        "Last name should be between 3 and 25 characters long"
      ),
    ],
    email: "",
    email_rules: [
      Utils.validate.is_required("Email address is required"),
      Utils.validate.email_format(
        "Invalide Email format, expected something like myname@xyz.com "
      ),
    ],
    phone_number: "",
    phone_number_rules: [
      Utils.validate.is_required("Phone number is required"),
    ],
    message: "",
    message_rules: [
      Utils.validate.is_required("Message is required"),
      Utils.validate.min_max_length(
        10,
        100,
        "Message length must be between 10 and 100 letters long"
      ),
      Utils.validate.min_words(7, "Message must contain atleast 7 words"),
    ],
    contact_form_errors: [],
    contact_us_success_message: "",
  }),
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 200);
      this.first_name = "Rand_First_Name_" + rnd;
      this.last_name = "Rand_Last_Name_" + rnd;
      this.email = "randemail" + rnd + "@gmail.com";
      this.phone_number = "+267" + (77393543 - (rnd + 37)); //could be right or wrong
      this.message = "This is the a sample mesage of random number " + rnd;
    },
    on_init_form(){
      if(this.this_user && this.this_user != null) {
        this.first_name = this.this_user.first_name;
        this.last_name = this.this_user.last_name;
        if(this.this_user.email.indexOf("@") > -1){
          this.email = this.this_user.email;
          this.phone_number = "";
        }else{
          this.phone_number = this.this_user.email;
          this.email = "";
        }
        this.message = "";
      }else{
        this.first_name = "";
        this.last_name = "";
        this.email = "";
        this.phone_number = "";
        this.message = "";
      }
      this.contact_form_errors = [];
      this.contact_us_success_message = "";
    },
    on_assign_email_and_phone_number(values) {
      this[values.prop] = values.value;
    },
    on_assign_first_name_and_last_name(values) {
      this[values.prop] = values.value;
    },
    on_send_message() {
      //form is already validated
      this.contact_form_errors = [];
      this.contact_us_success_message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.send_message(
        {
          owner_id: this.business.user_id,
          user_id: this.this_user.id,
          business_id: this.business.id,
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone_number: this.phone_number,
          message: this.message,
        },
        (res) => {
          this.contact_us_success_message =
            "<b class='success--text'>Thank you so much </b> for getting in touch with us";
          
          
          this.$refs.carded_owners_contact_form_ref.show_message_dialog();
          
          this.$emit("on-hide-loader");
        },
        (errors) => {
          this.contact_form_errors = errors;
          this.$refs.carded_owners_contact_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message(){
      this.on_init_form();
      this.$refs.carded_owners_contact_form_ref.on_clear_validations();
    }
  },
  mounted() {
    var temp_user = ServerClient.Login.get_logged_in_user();
    if (temp_user && temp_user != null) {
      this.this_user = temp_user;
    }else{
      this.this_user =  {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        phone_number: ""
      };
    }
    this.on_init_form();
    this.$refs.carded_owners_contact_form_ref.on_clear_validations();
  },
};
</script>